var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.92859 6.91359V25.8136C4.92843 25.9826 4.96425 26.1493 5.03323 26.3006C5.10221 26.4519 5.20246 26.5836 5.32609 26.6854C5.44971 26.7872 5.59333 26.8563 5.74561 26.8872C5.89789 26.9182 6.05467 26.9101 6.20359 26.8636L28.2036 19.8681C28.4126 19.8029 28.5965 19.6651 28.7273 19.4756C28.8582 19.2862 28.9288 19.0553 28.9286 18.8181V13.909C28.9288 13.6718 28.8582 13.441 28.7273 13.2515C28.5965 13.0621 28.4126 12.9243 28.2036 12.859L6.20359 5.86359C6.05467 5.81713 5.89789 5.80903 5.74561 5.83995C5.59333 5.87087 5.44971 5.93996 5.32609 6.04177C5.20246 6.14358 5.10221 6.27532 5.03323 6.42662C4.96425 6.57791 4.92843 6.74462 4.92859 6.91359Z",
    stroke: "#21BB8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9286 21.2318V26.1818C23.9286 26.4711 23.8232 26.7486 23.6357 26.9532C23.4482 27.1578 23.1938 27.2727 22.9286 27.2727H18.9286C18.6634 27.2727 18.409 27.1578 18.2215 26.9532C18.0339 26.7486 17.9286 26.4711 17.9286 26.1818V9.58636",
    stroke: "#21BB8E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.659be2fd.svg";
export { ForwardRef as ReactComponent };